export function setCookie(name, value, days, domain) {
  if (!name || !value) return;

  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000); // days to ms
  const expires = "expires=" + d.toUTCString();

  const domainPart = domain ? `; domain=${domain}` : ""; // TODO: not used

  // Use path=/ so the cookie is valid site-wide
  document.cookie = `${name}=${encodeURIComponent(value)}; ${expires}; domain=${domain}; path=/`;
}
